module.exports = "<span class=\"q-pill q-pill-min-sm {%- statusClass %}\"> {%- statusText %} </span>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/report/lookup/html/status.html
// module id = 1405
// module chunks = 1